import React from 'react';

import {
  createCouncilDecisionReport,
  getCouncilDecisionReportById,
  updateCouncilDecisionReport,
} from '../../../../services/taxonomies/council-decision-report';
import { useEditPage } from '../../../../hooks/useEditPage';
import { Default } from '../../../../layouts';
import EditCouncilDecisionReportForm from '../../../../components/council-decision-report/EditCouncilDecisionReportForm';

const initialCouncilDecisionReport = {
  deleted: false,
  reports: null,
  councilDecisionIds: null,
};

const EditCouncilDecisionReport = () => {
  const [councilDecisionReport, handleSubmit, handleCancel] = useEditPage({
    initial: initialCouncilDecisionReport,
    existent: getCouncilDecisionReportById,
    goBackPath: '/admin/taxonomies/council-decisions-reports',
    onCreate: createCouncilDecisionReport,
    onUpdate: updateCouncilDecisionReport,
  });

  return (
    <Default>
      {councilDecisionReport !== undefined && (
        <EditCouncilDecisionReportForm
          councilDecisionReport={councilDecisionReport}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
        />
      )}
    </Default>
  );
};

export default EditCouncilDecisionReport;
